<script lang="ts" setup>
  const props = defineProps<{
    disabled?: boolean
    testId: string
    triggerAriaLabel: string
  }>()

  const emit = defineEmits<{
    (e: 'activate'): void
  }>()

  const handleActivate = () => {
    if (!props.disabled) {
      emit('activate')
    }
  }

  const handleKeydown = (event: KeyboardEvent) => {
    if (props.disabled || (event.key !== 'Enter' && event.key !== ' ')) {
      return
    }

    event.preventDefault()
    emit('activate')
  }
</script>

<template>
  <button
    type="button"
    class="text-heading focus-visible:outline-primary w-full rounded-sm border-0 bg-transparent p-0 text-start hover:underline focus-visible:outline focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:no-underline disabled:opacity-60"
    :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
    :disabled="disabled"
    :aria-label="triggerAriaLabel"
    :data-testid="testId"
    @click="handleActivate"
    @keydown="handleKeydown"
  >
    <slot />
  </button>
</template>
